import { IntersectionRuleConfiguration } from "../../../rule-engine-core/Rule/Intersection/IntersectionRuleConfiguration";

export const getEmptyRuleDefinition = () => {
    return new IntersectionRuleConfiguration();
};
